export default "__VITE_ASSET__f1ced981__"